import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
import styled from 'styled-components';

export const StyledAlert = styled(Alert)`
    width: fit-content;
    max-width: 500px;
    margin: 12px 0 0px auto;
    text-align: left;
`;

export const StyledProgress = styled(CircularProgress)`
    width: 22px !important;
    height: 22px !important;
    margin-left: 10px;
    margin-bottom: -6px
`;